<span *ngIf="resource">{{resource.name}}</span>
